/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'gas_station': {
    width: 110,
    height: 114,
    viewBox: '0 0 110 114',
    data: '<path pid="0" d="M92.042 26.826c3.715 0 6.727-2.999 6.727-6.705v-6.705L110 2.241 103.259.006l-14.18 14.117c.562-.558-3.771 4.612-3.771 5.998v24.592l13.461 13.41v34.651a3.36 3.36 0 01-3.36 3.352c-1.861 0-3.374-1.5-3.374-3.352v-13.41c0-5.56-4.518-10.058-10.109-10.058H78.56l.007-62.601c0-3.7-3.012-6.705-6.734-6.705H13.468C9.746 0 6.734 2.999 6.734 6.705v100.59H0V114h85.322v-6.705H78.58l-.007-31.29h3.367c1.854 0 3.375 1.5 3.375 3.353V92.768c0 5.552 4.51 10.058 10.101 10.058 5.569 0 10.101-4.506 10.101-10.058V55.883L92.042 42.466v-15.64zm-26.936 13.41H20.198v-26.82h44.908v26.82z" _fill="#2B363B"/>'
  }
})
